import request from '@/CommonDP/utils/request';
export default {
// 校审区 我创建的流程
  getMySubmitList(enterpriseId, prjId, pageNum, pageSize, title) {
    return request.get(`/flow/proofreadingArea/mySubmit?enterpriseId=${enterpriseId}&prjId=${prjId}&pageNum=${pageNum}&pageSize=${pageSize}&title=${title}`);
  },
  // 校审区 待我处理的
  getMyAgencyList(enterpriseId, prjId, pageNum, pageSize, title) {
    return request.get(`/flow/proofreadingArea/myProcessing?enterpriseId=${enterpriseId}&prjId=${prjId}&pageNum=${pageNum}&pageSize=${pageSize}&title=${title}`);
  },
  // 校审区 我处理的
  getMyFinishedList(enterpriseId, prjId, pageNum, pageSize, title) {
    return request.get(`/flow/proofreadingArea/myProcessed?enterpriseId=${enterpriseId}&prjId=${prjId}&pageNum=${pageNum}&pageSize=${pageSize}&title=${title}`);
  },
  // 查询相关文件
  getFileListByFlowBusinessId(businessId) {
    return request.get(`/flow/getFileListByFlowBusinessId?businessId=${businessId}`);
  },
  // 同意当前节点
  agree(dto) {
    return request.post('/flow/flowInstance/agree', dto);
  },
  // 拒绝当前节点
  rejectNodeFlow(dto) {
    return request.post('/flow/flowInstance/rejectNodeFlow', dto);
  },
  // 批量下载
  downloadFileZip(params) {
    return request({
      responseType: "blob",
      url: "/download/file",
      method: "post",
      data: params
    });
  }
};
